import { Box, Stack, Typography } from '@mui/material';
import { useMemo } from 'react';

import { Button } from '@/components/form/baseInputs/Button';
import { ChevronLeftIcon } from '@/components/icons/ChevronLeftIcon';
import { EMPTY_CONTENT_HYPHEN } from '@/components/typography/placeholders';

import {
  BORDER_COLOR,
  HEADER_HEIGHT_PX,
} from '../../PresentationTemplateEditor.constants';
import { usePresentationTemplateEditorContext } from '../../PresentationTemplateEditor.context';
import { getBundleTileLabel } from '../presentationTemplate/bundleTile/PresentationTemplateBundleTile.utils';
import { usePresentationTemplateSlideEditorContext } from './PresentationTemplateSlideEditor.context';

export function PresentationTemplateSlideEditorHeader() {
  const { bundlesFormArray, selectedBundleId } =
    usePresentationTemplateEditorContext();
  const { handleSaveAll, handleCancel } =
    usePresentationTemplateSlideEditorContext();

  const bundleLabel = useMemo(() => {
    const bundle = bundlesFormArray.fields.find(
      (b) => b.id === selectedBundleId
    );
    return bundle ? getBundleTileLabel(bundle) : null;
  }, [selectedBundleId, bundlesFormArray.fields]);

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      height={HEADER_HEIGHT_PX}
      borderBottom={`1px solid ${BORDER_COLOR}`}
      px={1.5}
    >
      <Box flex="1 1 33%">
        <Button
          variant="transparent"
          size="sm"
          startIcon={ChevronLeftIcon}
          onClick={handleCancel}
        >
          Exit without saving
        </Button>
      </Box>
      <Stack direction="column" alignItems="center" flex="1 1 33%">
        <Typography variant="title-xs">Edit pages</Typography>
        <Typography variant="body-xs">
          {bundleLabel ?? EMPTY_CONTENT_HYPHEN}
        </Typography>
      </Stack>
      <Box flex="1 1 33%" display="flex" justifyContent="flex-end">
        <Button variant="primary" size="sm" onClick={handleSaveAll}>
          Done
        </Button>
      </Box>
    </Stack>
  );
}
